const templateUrl = require('./reactivate-subscription.html');

module.exports = {
  bindings: {
    subscription: '<ogFor'
  },
  controller: require('./reactivate-subscription.controller'),
  templateUrl: templateUrl
};
